import React, { createContext, ReactNode, useState } from 'react';
import { Meeting } from '../types';

interface MeetingDrawerState {
  isOpen: boolean;
  meeting: Meeting | null;
  mode: 'create' | 'edit' | 'view';
  projectId?: string;
  defaultStartTime?: Date;
  defaultEndTime?: Date;
  onSave?: () => void;
  onDelete?: () => void;
}

interface MeetingDrawerContextType {
  drawerState: MeetingDrawerState;
  openMeetingDrawer: (config: {
    mode: 'create' | 'edit' | 'view';
    meeting?: Meeting | null;
    projectId?: string;
    defaultStartTime?: Date;
    defaultEndTime?: Date;
    onSave?: () => void;
    onDelete?: () => void;
  }) => void;
  closeMeetingDrawer: () => void;
}

export const MeetingDrawerContext = createContext<MeetingDrawerContextType | undefined>(undefined);

interface MeetingDrawerProviderProps {
  children: ReactNode;
}

export const MeetingDrawerProvider: React.FC<MeetingDrawerProviderProps> = ({ children }) => {
  const [drawerState, setDrawerState] = useState<MeetingDrawerState>({
    isOpen: false,
    meeting: null,
    mode: 'create',
    projectId: undefined,
    onSave: undefined,
    onDelete: undefined,
  });

  const openMeetingDrawer = (config: {
    mode: 'create' | 'edit' | 'view';
    meeting?: Meeting | null;
    projectId?: string;
    defaultStartTime?: Date;
    defaultEndTime?: Date;
    onSave?: () => void;
    onDelete?: () => void;
  }) => {
    setDrawerState({
      isOpen: true,
      meeting: config.meeting || null,
      mode: config.mode,
      projectId: config.projectId,
      defaultStartTime: config.defaultStartTime,
      defaultEndTime: config.defaultEndTime,
      onSave: config.onSave,
      onDelete: config.onDelete,
    });
  };

  const closeMeetingDrawer = () => {
    setDrawerState(prev => ({
      ...prev,
      isOpen: false,
      meeting: null,
    }));
  };

  return (
    <MeetingDrawerContext.Provider
      value={{
        drawerState,
        openMeetingDrawer,
        closeMeetingDrawer,
      }}
    >
      {children}
    </MeetingDrawerContext.Provider>
  );
};
